export default "__VITE_ASSET__23af8b09__"